import React, { Component } from 'react'

import WalletTransfer from "components/WalletTransfer/WalletTransfer";

export default class WalletTransferView extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Transferencia entre Billeteras</h1>
                    </div>
                </div>

                <WalletTransfer />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/WalletTransferView/WalletTransferView.jsx